export enum Pathnames {
    DEFAULT = '/',
    VEHICLE_DETAILS = 'vehicle',
    SETTINGS = 'settings',
}

const setHeaderTitle = (pathname: string) => {
    switch (true) {
        case pathname.includes(Pathnames.VEHICLE_DETAILS):
            return 'vehicle details';
        case pathname.includes(Pathnames.SETTINGS):
            return 'settings';
        default:
            return 'monitoring';
    }
};

export default setHeaderTitle;
